module.exports = __webpack_public_path__ + "img/about.1ef81f29.jpg";